module.exports = __webpack_public_path__ + "img/PT5270.a7fceb78.png";